// extracted by mini-css-extract-plugin
export default {"title":"registrationFinish_title__O+TNb","content":"registrationFinish_content__vF4Wa","right":"registrationFinish_right__j54SM"};